import { render, staticRenderFns } from "./PermissionRequired.vue?vue&type=template&id=5a77015b&scoped=true"
import script from "./PermissionRequired.vue?vue&type=script&lang=js"
export * from "./PermissionRequired.vue?vue&type=script&lang=js"
import style0 from "./PermissionRequired.vue?vue&type=style&index=0&id=5a77015b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a77015b",
  null
  
)

export default component.exports